var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('H5ActivityView',{staticClass:"mall-h5-activity-view",class:[_vm.bottomClassName],attrs:{"options":_vm.data,"customWidgets":_vm.customWidgets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }